import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import jobSlice from "../features/job/jobSlice";
import jobsSlice from "../features/jobs/jobsSlice";
import jobsFilterSlice from "../features/jobsFilter/jobsFilterSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    jobs: jobsSlice,
    jobsFilter: jobsFilterSlice,
    jobOnEdit: jobSlice,
  },
});
